import { Spin } from 'aa_common/front-end/antd'

import { acceleratedEventLogStore } from '../../store/accelerated-log'
import { AcceleratedDepreciationTable } from './accelerated-depr-table'
import { PlannedDate } from './planned-date'

export const AcceleratedDepreciationHistory = ({ isRegisterEvent }: { isRegisterEvent: boolean }) => {
  const isLoading = acceleratedEventLogStore.useSlice(state => state._loading)
  return (
    <Spin loading={isLoading}>
      <PlannedDate />
      <AcceleratedDepreciationTable isRegisterEvent={isRegisterEvent} />
    </Spin>
  )
}
